import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { mapMutations, mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'ViewDigitalTwinDigitalTwinOverview',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      favouriteFilter: false,
      twinCreateDialog: false,
      showExportDialog: false,
      twinCreateFormValid: false,
      isCreatingTwin: false,
      createDialogButtons: [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.saveAndCreate'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }],
      createTwinObject: {
        properties: {},
        data: {}
      },
      selected: null,
      favType: 'digitalTwin',
      favId: null,
      treeLoading: false,
      search: '',
      open: [],
      counter: 0,
      buttons01: [{
        title: this.$i18n_t('Common.addNew'),
        icon: 'fal fa-plus',
        valid: true
      }],
      initialActiveDtwinId: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    hasManageAllPermission: function hasManageAllPermission() {
      return this.permissions['all.manage'];
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    headerBG: function headerBG() {
      return './img/board-30.png';
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return function (v) {
        return !!v && v.trim() !== '' || _this.$i18n_t('Common.fieldRequired');
      };
    }
  }),
  watch: {
    selected: function selected() {
      if (this.selected) {
        if ("".concat(this.$route.query.active) !== "".concat(this.selected.id)) {
          this.initialActiveDtwinId = this.selected.id;
          this.$route.query.active = this.selected.id;
        }
      }

      this.$route.query.search = this.search;
    },
    '$route.query.active': {
      handler: function handler() {
        this.initialActiveDtwinId = this.$route.query.active ? parseInt(this.$route.query.active) : null;
      }
    },
    search: function search() {
      this.didSelectTwin(this.selected);
    }
  },
  created: function created() {
    this.$store.state.app.loading = false;
    this.initialActiveDtwinId = this.$route.query.active ? parseInt(this.$route.query.active) : null;
    this.search = this.$route.query.search ? this.$route.query.search : '';
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    get: get,
    createTwin: function createTwin(selected) {
      this.createTwinObject = {
        properties: {},
        data: {},
        tenantId: selected.tenantId,
        parentId: selected.id,
        reuseParentScope: false // reset to false by MWa 22.12.2021 - PM wanted it that way
        // I have explained why we set it to true - we want to do it again in 2022 after
        // informing customers about changed way to create twins

      };
      this.twinCreateDialog = true;
    },
    saveAndCreateTwin: function saveAndCreateTwin() {
      var _this2 = this;

      this.isCreatingTwin = true;
      return ApiService.digitalTwinCreate(this, this.createTwinObject).then(function (result) {
        _this2.isCreatingTwin = false;
        _this2.twinCreateDialog = false;

        _this2.$snack(_this2.$i18n_t('Common.digitalTwins.twinCreated'), 'success');

        _this2.pushToRouter("/digitaltwin-mgmt/".concat(result.id));

        _this2.$store.state.app.dtwins = {};
        _this2.selected = null;
        _this2.initialActiveDtwinId = null;

        if (_this2.$refs['twin-tree']) {
          _this2.$refs['twin-tree'].activeDtwinId = null;

          _this2.$refs['twin-tree'].initTree();
        }
      }).catch(function (error) {
        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('Common.digitalTwins.twinCreatedFail'), 'error');
        }
      }).finally(function () {
        _this2.isCreatingTwin = false;
        _this2.$store.state.app.loading = false;
      });
    },
    deleteTwin: function deleteTwin(selected) {
      var _this3 = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.$store.state.app.dtwins = {};
      ApiService.digitalTwinDelete(selected.id).then(function () {
        _this3.$snack(_this3.$i18n_t('Common.digitalTwins.twinDeleted'), 'success');

        _this3.$store.state.app.dtwins = {};

        _this3.selectedDigitalTwin(selected);

        if (_this3.$refs['twin-tree']) {
          _this3.$refs['twin-tree'].activeDtwinId = null;

          _this3.$refs['twin-tree'].initTree();
        }
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.digitalTwins.twinDeletedFail'), 'error');
        }
      }).finally(function () {
        _this3.$store.state.app.loading = false;
      });
    },
    loadedInitialDtwins: function loadedInitialDtwins(dtwins) {
      if (dtwins && dtwins.length > 0) {
        this.didSelectTwin(this.selected || dtwins[0]);
      }
    },
    didSelectTwin: function didSelectTwin(e) {
      if (e && e.id) {
        this.selected = e;
        var url = window.location.href;
        window.location.href = url.split('?')[0];
        window.location.href += "?active=".concat(e.id);

        if (this.search) {
          window.location.href += "&search=".concat(this.search);
        }
      }
    },
    highlightTwinName: function highlightTwinName(twinName) {
      if (this.search) {
        return twinName.replace(new RegExp("(".concat(this.search, ")"), 'gi'), '<span style="font-weight: bold">$1</span>');
      }

      return twinName;
    },
    pushToRouter: function pushToRouter(path) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.$router.push({
        path: path,
        query: {
          parent: selected ? selected.id : null
        }
      });
    },
    selectedDigitalTwin: function selectedDigitalTwin(item) {
      this.initialActiveDtwinId = item.parentId;
      this.$router.replace({
        path: '/digitaltwin-mgmt',
        query: {
          active: item.parentId
        }
      });
      this.selected = item;
      this.open = this.$refs['twin-tree'].open;
      this.counter++;
    }
  })
};